import * as api from '../../services/reward'
import lodash from 'lodash'

export const FETCH_REWARDS= 'FETCH_REWARDS';
export const FETCH_REWARDDETAILS= 'FETCH_REWARDDETAILS';
export const FETCH_REWARDTARGETS= 'FETCH_REWARDTARGETS';




export const fetchRewards = (params, pagination, sort, extra) => {

    return {
        type: FETCH_REWARDS,
        payload: {
            promise: api.findRewards(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params, 'ownership'),
            sort: sort,
            extra: extra
        }
    };
};
export const fetchRewardDetails = (params, pagination, sort, extra) => {

    return {
        type: FETCH_REWARDDETAILS,
        payload: {
            promise: api.findRewardDetails(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};
export const fetchRewardTargets= (params, pagination, sort, extra) => {

    return {
        type: FETCH_REWARDTARGETS,
        payload: {
            promise: api.findRewardTargets(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/reward.js